<script>
import {mapState} from 'vuex';

import poweredBanner from 'assets/images/powered_banner.png';
import FooterColumn from './FooterColumn';

class FooterLink {
  constructor(text, uri, external = false, hash) {
    this.text = text;
    this.uri = uri;
    this.external = external;
    this.hash = hash;
  }
};

export default {
  components: {
    FooterColumn,
  },
  data: () => ({
    columns: {
      'For Buyers': [
        new FooterLink('Track Order', 'trackOrder'),
        new FooterLink('Contact Us', 'contact'),
      ],
      Help: [
        new FooterLink('FAQs', 'faq'),
        new FooterLink('Returns', 'returns'),
      ],
      Policies: [
        new FooterLink('Terms', 'terms'),
        new FooterLink('Privacy', 'privacy'),
        new FooterLink('Copyright', 'copyright'),
      ],
    },
    heights: {
      'For Buyers': 84,
      Help: 84,
      Policies: 120,
    },
    poweredBanner,
  }),
  computed: {
    ...mapState(['domainConfig']),
  },
};
</script>

<template lang='pug'>
footer.bg-brand-secondary.font-archivo-narrow
  .py-3.mx-auto.px-_5.md_py-5.container
    .w-full.md_w-8-12.lg_w-6-12.flex.flex-wrap.justify-around.lg_justify-between.mx-auto
      footer-column(
        v-for='(links, title) in columns',
        :key='title',
        :title='title',
        :links='links',
        :open-default='title === "Company"',
        :height='heights[title]',
      )
    .flex.w-full.mt-2.justify-around.flex-wrap(v-if='domainConfig.display_powered_by_vs == 1')
      img.opacity-100.h-4.bg-white.rounded-lg(:src='poweredBanner')
</template>

<style>
@import '~import/index';
</style>